angular.module('shared').directive('autoHideSuccessAlert', ["$timeout", function($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element) {
      var hide;
      $timeout(function() {
        return scope.unbindWatcher = scope.$on('$locationChangeSuccess', function() {
          return hide();
        });
      });
      $timeout(function() {
        if (angular.element('.worx-loading-background').hasClass('hidden')) {
          return hide();
        }
      }, 3000);
      return hide = function() {
        if (element.hasClass('flash-success')) {
          element.removeClass('active');
          return scope.unbindWatcher();
        }
      };
    }
  };
}]);
